import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "widget-main" }
const _hoisted_2 = { class: "all-groups-container" }
const _hoisted_3 = { class: "all-groups" }
const _hoisted_4 = { class: "group" }
const _hoisted_5 = ["data-text"]
const _hoisted_6 = { class: "group-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_layout = _resolveComponent("widget-layout")!

  return (_openBlock(), _createBlock(_component_widget_layout, {
    class: _normalizeClass(["groups-summary", `width${_ctx.width}`]),
    minHeight: 2,
    maxHeight: 2,
    maxWidth: 2,
    loading: !_ctx.data,
    menuColour: "#fff"
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "title" }, [
        _createElementVNode("h4", null, "Users Summary")
      ], -1),
      _createElementVNode("div", { class: "description" }, [
        _createElementVNode("p", null, "An overview of your users and cohorts")
      ], -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsData, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "group-container",
                key: group
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "group-pill",
                    style: _normalizeStyle(`min-height: ${group?.height ?? '0'}%`)
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", { class: "dot" }, null, -1)
                  ]))], 4),
                  _createElementVNode("span", {
                    "data-text": `${group?.users ?? '0'} Users`
                  }, " ", 8, _hoisted_5)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(group?.name ?? ""), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "class"]))
}